import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { AgreementService } from '@fi-app/agreement/agreement.service';
import { FiAuthenticateModuleService } from '../authenticate-module.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AgreementPublishedContentModel } from '@fi-shared/fi-agreement/agreement-published-content.model';
import { AgreementModel } from '@fi-shared/fi-agreement/agreement.model';
import { ILoginData } from '@fi-shared/fi-auth-shared/fi-auth-shared';

@Component({
    selector: 'fi-authenticate-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['../authenticate.scss', './agreement.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-authenticate-agreement' },
    standalone: false,
})
export class FiAuthenticateAgreementComponent implements OnInit {
    @Input() agreement: AgreementModel;
    protected agreementPublishedContent: AgreementPublishedContentModel;

    protected isAccepted = signal(false);

    private loadingService = inject(LoadingService);
    private agreementService = inject(AgreementService);
    private authModuleService = inject(FiAuthenticateModuleService);
    private stateService = inject(FiStateService);

    public ngOnInit(): void {
        this.agreementPublishedContent = this.agreement.GetPublishedContentByContentLanguage(
            this.stateService.params.UserPreferredContentLanguageId,
            this.stateService.params.DefaultContentLanguageId,
        );
    }

    protected decline(): void {
        this.stateService.go(FiStateNames.Login.Auth);
    }

    protected accept(): void {
        const loading = this.loadingService.startLoading();
        this.agreementService
            .AcceptAgreement(
                this.agreement,
                this.agreementPublishedContent.ContentLanguageId,
                this.stateService.params.agreementNotAcceptedResponse.UserId,
                this.agreementPublishedContent.AgreementVersion,
            )
            .then(() => {
                loading();
                if (this.stateService.params.adCredentials) {
                    this.authModuleService.loginWithAd(this.stateService.params.adCredentials);
                } else {
                    const loginData: ILoginData = this.stateService.params.loginData;
                    this.authModuleService.LoginWithCredentials(loginData);
                }
            }, loading);
    }
}
